import { IPassiveSkill } from "../ISkill";
import CharacterAttributes from "../../Character/CharacterAttributes";

export default class CriticalMasterySkill implements IPassiveSkill {
  Name = "Critical Mastery";
  Description = "Increases critical strike chance.";
  MaxLevel = 5;
  IconKey = "skill_crit_mastery";

  ApplyBonus(level: number, attributes: CharacterAttributes): void {
    attributes.Dexterity += level * 3;
  }
}
